(function () {
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduced) {
    document.querySelectorAll(".z-rv").forEach(function (el) { el.classList.add("z-in"); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add("z-in"); io.unobserve(e.target); }
    });
  }, { threshold: 0.1, rootMargin: "0px 0px -6% 0px" });
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".z-rv").forEach(function (el) { io.observe(el); });
  });
})();
